function countryCodeToFlag(countryCode) {
  const normalizedCode = String(countryCode || '').trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(normalizedCode)) return '';
  return [...normalizedCode]
    .map((character) => String.fromCodePoint(character.charCodeAt(0) + 127397))
    .join('');
}

function updateDestination(destination, countryName, countryCode, source) {
  const nameNode = destination.querySelector('[data-ls-country-name]');
  const flagNode = destination.querySelector('[data-ls-country-flag]');
  const flag = countryCodeToFlag(countryCode);

  if (countryName && nameNode) nameNode.textContent = countryName;
  if (flagNode) {
    flagNode.textContent = flag;
    flagNode.hidden = !flag;
  }

  destination.dataset.countryCode = countryCode || '';
  destination.dataset.countrySource = source;
}

function localizeCollectionHeader(scope = document) {
  const destinations = [...scope.querySelectorAll('[data-ls-collection-country]')];
  if (!destinations.length) return;

  destinations.forEach((destination) => {
    const countryName = destination.querySelector('[data-ls-country-name]')?.textContent.trim();
    updateDestination(destination, countryName, destination.dataset.countryCode, 'localization');
  });

}

if (typeof document !== 'undefined') {
  localizeCollectionHeader();
  document.addEventListener('shopify:section:load', (event) => localizeCollectionHeader(event.target));
}

export { countryCodeToFlag, localizeCollectionHeader };
